module.exports = __webpack_public_path__ + "img/chevron-left.ee9bdf4c.svg";